module.exports = __webpack_public_path__ + "static/media/sz.b6570643.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sz.svg
// module id = 258
// module chunks = 0